import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  CssBaseline,
  Box,
  Container,
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LogoutIcon from '@mui/icons-material/Logout';

import Knowledge from './components/Knowledge';
import Copy from './components/Copy';
import Prompt from './components/Prompt';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';

const menuItems = [
  { text: 'Knowledge', path: '/', icon: LightbulbOutlinedIcon },
  { text: 'User Prompt', path: '/prompt', icon: QuestionAnswerOutlinedIcon },
  { text: 'Copy', path: '/copy', icon: ContentCopyIcon },
];

const AppContent = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerList = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {menuItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <ListItemButton component={Link} to={item.path} key={item.text}>
              <IconButton edge="start" color="inherit" sx={{ mr: 2 }}>
                <Icon />
              </IconButton>
              <ListItemText primary={item.text} />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <img
            src="/mazelogo.png"
            alt="Logo"
            style={{ marginRight: '10px', marginTop: '10px', marginBottom: '10px', height: '60px' }}
          />
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Adaptive Marketing
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <Button color="inherit" component={Link} to={item.path} key={item.text} startIcon={<Icon />}>
                  {item.text}
                </Button>
              );
            })}
            <Button color="inherit" onClick={logout} startIcon={<LogoutIcon />}>
              Logout
            </Button>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{ display: { xs: 'block', sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{ display: { xs: 'block', sm: 'none' } }}
      >
        {drawerList()}
      </Drawer>
      <Container style={{ marginTop: '2rem' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Knowledge />
            </ProtectedRoute>
          } />
          <Route path="/prompt" element={
            <ProtectedRoute>
              <Prompt />
            </ProtectedRoute>
          } />
          <Route path="/copy" element={
            <ProtectedRoute>
              <Copy />
            </ProtectedRoute>
          } />
        </Routes>
      </Container>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <CssBaseline />
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;

